import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const webfleetConfig: TSPConfig = {
  key: 'webfleet',
  name: 'Webfleet',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the credentials and company account name you use to log into the Webfleet App.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default webfleetConfig;
